<template>
    <div style="width:calc(33%)!important">
        <div id="chat" :class="{open:open}">
            <div class="chat-trigger bg-gray-900" :class="{highlighted: unread > 0}" v-cloak>
                <a href="#" v-if="!open" @click.prevent="toggleViewing()">
                    <i class="fa fa-comment"></i> Messages
                </a>
                <span v-show="!open && unread > 0" class="widget-badge">{{ unread }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import MessageWidget from "./widgets/MessageWidget/MessageWidget.vue";

export default {
    components: {MessageWidget},
    props: [],
    filters: {
        truncate: function (text, stop, clamp) {
            return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
        }
    },
    data() {
        return {
            open: false,
            unread: 0,
            recentsOnly: true,
            newMessage: "",
            chatting: false,
            currentChattingUser: null,
            chatTranscript: null,
            users: [],
        }
    },
    computed: {},
    methods: {
        toggleViewing: function () {
            window.Bus.emit('open-messaging')
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import '../../sass/setup';

#chat {
    z-index: 5;
    position: relative;

    @include grid-media($mobileMenu) {
        display: inline-block;
        margin-right: 0.5em;
    }

    float: none;
    margin-right: 0;

    .chat-container {
        display: none;
        background-color: #FFF;
        padding: 1em;
        overflow-y: scroll;
        overflow-x: hidden;
        position: relative;
        -webkit-overflow-scrolling: touch;

        @include grid-media($mobileMenu) {
            width: 420px;
            height: 350px;
        }

        nav {
            @include desktop() {
                padding-bottom: 1em;
            }

            ul li {
                line-height: 19px;
                font-size: 13px;
                @include clearfix;
                margin-bottom: 0.7em;

                background-color: rgba(0, 0, 0, 0.04);
                border-radius: 0.3em;
                padding: 1em;
                text-align: left;

                &.unread {
                    background-color: rgba(0, 136, 206, 0.2);
                }

                .name {
                    float: left;

                }

                .timestamp {
                    float: right;
                    font-size: 0.8em;
                }

                .avatar {
                    float: left;
                    width: 30px;
                    margin-right: 8px;
                    margin-top: 5px;

                    img {
                        border-bottom: 3px solid black;

                        &.green {
                            border-bottom-color: #70a770;
                        }

                        &.orange {
                            border-bottom-color: #b97933;
                        }

                        &.red {
                            border-bottom-color: #944e4e;
                        }
                    }
                }

                small {
                    display: block;
                    font-size: 0.8em;
                    color: #999;
                }

                a {
                    text-decoration: none;
                    font-weight: 500;
                }
            }
        }

        main {
            padding-bottom: 50px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            @include grid-media($mobileMenu) {
                position: relative;
                width: auto;
            }

            div {
                position: absolute;
                overflow-x: hidden;
                overflow-y: scroll;
                -webkit-overflow-scrolling: touch;
                width: 100%;
                top: 0;
                left: 0;
                padding: 1em 1em 0;
                height: calc(100% - 41px);
                @include grid-media($mobileMenu) {
                    height: 290px;
                    padding: 0;
                }
            }

            article {
                margin-bottom: 1em;
                padding: 0.5em;
                font-size: 13px;
                border-radius: $standardBorderRadius;
                width: 80%;
                margin-right: 20%;
                background-color: #ecf0f1;
                color: #3d3e44;

                &.yours {
                    color: #fff;
                    background-color: $brand;
                    margin-left: 20%;
                }

                p {
                    margin: 0;
                }

                span {
                    font-size: 80%;
                    opacity: 0.6;
                    display: block;
                }

                span.right {
                    text-align: right;
                }
            }

            input {
                position: absolute;
                bottom: 0;
                left: 1em;
                font-size: 13px;
                width: calc(100% - 2em);

                @include grid-media($mobileMenu) {
                    left: 0;
                    width: 100%;
                    margin-bottom: 0;
                }
            }
        }
    }

    div.chat-trigger {
        padding: 0.4em 1em;
        font-size: 12px;

        a {
            display: block;
            color: #FFF;
            text-decoration: none;

            .fa {
                margin-right: 5px;
            }

            &:hover {
                color: $yellow;
            }
        }

        @include mobile() {
            padding: 10px 1em 4px;
            background-color: $brand;
            text-align: center;
            font-size: 12px;
            a .fa {
                display: block;
                margin: 0.1em auto;
                height: 20px;
                font-size: 16px;
            }
            &.highlighted a {
                color: $yellow;
            }
        }

        @include grid-media($mobileMenu) {
            border-radius: $standardBorderRadius $standardBorderRadius 0 0;
            a {
                display: inline;
            }
        }
    }

    .chat-scroller {
        position: absolute;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        width: 100%;
        top: 0;
        left: 0;
        padding: 1em;
        height: calc(100% - 1em - 30px);
        @include grid-media($mobileMenu) {
            position: relative;
            height: auto;
            width: auto;
        }
    }

    &.open {
        box-shadow: -4px -4px 4px 0px rgba(0, 0, 0, 0.06);
        z-index: 10;
        top: 0;
        width: 100%;
        height: 100%;
        position: absolute;

        @include grid-media($mobileMenu) {
            width: auto;
            height: auto;
            position: relative;
            margin-top: -348px;
            top: 6px;
        }

        .chat-trigger {
            @include clearfix();

            a:first-of-type {
                float: left;
                color: #FFF;
            }

            a:last-of-type {
                float: right;
                color: #FFF;
            }

            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 40px;
            @include grid-media($mobileMenu) {
                position: relative;
                width: auto;
                height: auto;
            }
            @include mobile() {
                a {
                    padding-top: 2px;

                    .fa {
                        display: inline-block;
                        margin: 0;
                        height: auto;
                    }
                }
            }
        }

        .chat-container {
            display: block;
            width: 100%;
            height: calc(100% - 30px);
            position: absolute;
            top: 0;
            margin-top: 40px;
            @include grid-media($mobileMenu) {
                display: block;
                width: 420px;
                height: 350px;
                margin-top: 0;
                position: relative;
            }
        }
    }

}

.widget-badge {
    background-color: $yellow;
    border-radius: 50%;
    padding: 0.3em 0.5em 0.4em 0.44em;
    font-size: 9px;
    color: #000;
    font-weight: 700;
    margin-left: 7px;
    display: inline-block;
    width: 20px;
    text-align: center;
    @include mobile() {
        float: right;
        margin-top: -45px;
    }
}

[v-cloak] {
    display: none;
}
</style>
